import React from 'react';
import styles from './category-second.module.scss';
import Skeleton from 'react-loading-skeleton';
import Breadcrumbs from '@/components/ui/breadcrumbs';
import { useTranslations } from 'next-intl';

export type SecondContentHeaderProps = {
  loading: boolean;
  breadData: { title: string; link: string }[];
  categoryName: string | undefined | null;
  selectedProductIds: string[];
  productsVariants: number;
  totalCount: number | undefined | null;
  showSkeletons?: boolean;
  isTopSeller: boolean;
};

const SecondContentHeader: React.FC<SecondContentHeaderProps> = ({
  loading,
  breadData,
  categoryName,
  selectedProductIds,
  productsVariants,
  totalCount,
  showSkeletons = false,
  isTopSeller,
}) => {
  const t = useTranslations('Components.category-second-content');
  return (
    <div>
      {loading || showSkeletons ? (
        <h2 className={styles.skeletonForLinks}>
          <Skeleton />
        </h2>
      ) : (
        <Breadcrumbs data={breadData} />
      )}
      <div className={styles.header}>
        {loading || showSkeletons ? (
          <h2 className={styles.skeletonForHeader}>
            <Skeleton />
          </h2>
        ) : (
          <div className={styles.categoryNameWrapper}>
            <h2>
              {isTopSeller ? t('sales-liders-in-category') : categoryName}
            </h2>
            <p>
              {selectedProductIds.length === 0 ? totalCount : productsVariants}{' '}
              {t('products')}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SecondContentHeader;
